import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveExperience,
  createExperience,
  deleteExperience,
  getAllActiveExperiences,
  getAllExperiences,
  getExperienceByID,
  ExperienceImageUpload,
  updateExperience,
} from "./services/experience.services";
import { IExperience, IExperienceInitialState } from "./experienceModel";

const initialState: IExperienceInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  ExperienceID: null,
  ExperienceList: [],
  ExperienceDetail: {
    ID: null,
    Title: "",
    Description: "",
    SequenceNo: null,
    Image: "",
    IsActive: 1,
  },
};

const experienceSlice = createSlice({
  name: "experience",
  initialState,
  reducers: {
    clearExperienceDetails: (state) => {
      state.ExperienceDetail = initialState.ExperienceDetail;
    },
    setExperienceID: (state, action) => {
      state.ExperienceID = action.payload;
    },
    clearExperienceID: (state) => {
      state.ExperienceID = initialState.ExperienceID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllExperiences.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllExperiences.fulfilled,
      (state, action: PayloadAction<IExperience[]>) => {
        state.loading = false;
        state.ExperienceList = action.payload || [];
      },
    );
    builder.addCase(getAllExperiences.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ExperienceList = [];
    });
    builder.addCase(createExperience.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createExperience.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createExperience.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateExperience.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateExperience.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateExperience.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteExperience.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteExperience.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteExperience.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getExperienceByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getExperienceByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.ExperienceDetail = action.payload;
    });
    builder.addCase(getExperienceByID.rejected, (state, action) => {
      state.formLoading = false;
      state.ExperienceDetail = initialState.ExperienceDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveExperiences.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveExperiences.fulfilled,
      (state, action: PayloadAction<IExperience[]>) => {
        state.loading = false;
        state.ExperienceList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveExperiences.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ExperienceList = [];
    });

    builder.addCase(ActiveInactiveExperience.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveExperience.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveExperience.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(ExperienceImageUpload.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(ExperienceImageUpload.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(ExperienceImageUpload.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearExperienceDetails, clearExperienceID, setExperienceID } =
  experienceSlice.actions;
export default experienceSlice.reducer;
